import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_IGNORED_DETAILS_MUTATION = gql`
  mutation updateDishTypeIgnoredDetails(
    $id: ID!
    $data: DishTypeIgnoredDetailsInput!
  ) {
    updateDishTypeIgnoredDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      isIgnored
      courseTypeId
    }
  }
`

export default UPDATE_DISH_TYPE_IGNORED_DETAILS_MUTATION
